export const RGetSpecByName = '/admin/admin/specialists/v1/byName?name=';
export const RGetSpecInfo = '/admin/admin/slots/v1/bySpecId?specId=';
export const RGetClientInfo = '/admin/admin/users/v1/clientByInfo?info=';

export const RCreateSessionByAdmin = `/admin/admin/order/v1/create`;
export const RGetAllSessionsByAdmin = `/admin/admin/order/v1/all`;
export const RCancelSessionByAdmin = `/admin/admin/order/v1/cancel/by-session`;
export const RUpdateUserInfoByAdmin = `/admin/admin/users/v1/contact`;
export const RClientCreationByAdmin = '/admin/admin/users/v1';